export const palette = {
  mode: 'light' as const,

  primary: {
    main: '#5B21B6',
    light: '#7C3AED',
    dark: '#3B0F82',
    contrastText: '#FFFFFF',
  },

  secondary: {
    main: '#DB2777',
    light: '#EC4899',
    dark: '#9D174D',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#D97706',
    light: '#F59E0B',
    dark: '#92400E',
    contrastText: '#FFFFFF',
  },

  success: {
    main: '#059669',
    light: '#10B981',
    dark: '#065F46',
    contrastText: '#FFFFFF',
  },

  error: {
    main: '#DC2626',
    light: '#EF4444',
    dark: '#991B1B',
    contrastText: '#FFFFFF',
  },

  background: {
    default: '#F8FAFC',
    paper: '#FFFFFF',
  },

  text: {
    primary: '#0F172A',
    secondary: '#64748B',
    disabled: '#94A3B8',
  },

  divider: 'rgba(15, 23, 42, 0.08)',
};
